module.exports = __webpack_public_path__ + "img/005.8702be58.jpg";